import { SET_ACTIVE_VIEW } from "../constants/actionTypes";

const initialState = {
  EFile: false,
  Tax: false,
  History: false,
  User: false,
};

export const headerbgToggle = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_VIEW:
      return Object.keys(state).reduce((acc, key) => {
        acc[key] = key === action.payload;
        return acc;
      }, {});
    default:
      return state;
  }
};
